import React, { useCallback } from "react";
import { connect } from "react-redux";

import { faBars } from "@fortawesome/pro-solid-svg-icons/faBars";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { defineMessages, useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import Interactive from "@app/component/map/FeaturedMap/essentials/controls/Interactive";
import { showSidebar } from "@app/scene/map/store/mapMode/actions";
import { isSidebarVisible } from "@app/scene/map/store/mapMode/selectors";
import { RootState } from "@app/store/rootReducer";
import useAnalytics from "@app/util/contexts/useAnalytics";

import styles from "./OpenListButton.module.scss";

interface Props {
  showSidebar: typeof showSidebar;
  sidebarVisible: boolean;
}

const messages = defineMessages({
  title: {
    id: "map.toolbar.topCommands.openList",
    defaultMessage: "Open List",
    description: "Open List button title",
  },
});

const OpenListButton: React.FC<Props> = ({ showSidebar, sidebarVisible }) => {
  const intl = useIntl();
  const analytics = useAnalytics();

  const handleShowSidebar = useCallback(() => {
    showSidebar();
    analytics.clicked(["Open List"]);
  }, [analytics, showSidebar]);

  return sidebarVisible ? null : (
    <Interactive>
      <Button
        className={styles.btn}
        onClick={handleShowSidebar}
        rightIcon={<FontAwesomeIcon icon={faBars} />}
        type="text"
      >
        {intl.formatMessage(messages.title)}
      </Button>
    </Interactive>
  );
};

const mapStateToProps = (state: RootState) => ({
  sidebarVisible: isSidebarVisible(state),
});

const mapDispatchToProps = {
  showSidebar,
};

export default connect(mapStateToProps, mapDispatchToProps)(OpenListButton);
